import { modifier } from 'ember-modifier';

export default modifier((element, [callback]) => {
  let isVisible = false;
  let ticking = false;
  const scrollThreshold = 150; // Reducido un poco para mejor UX

  const handleScroll = () => {
    if (!ticking) {
      requestAnimationFrame(() => {
        const currentScroll = window.scrollY;
        const shouldShow = currentScroll > scrollThreshold;

        if (shouldShow !== isVisible) {
          isVisible = shouldShow;
          callback(isVisible);
        }
        ticking = false;
      });
      ticking = true;
    }
  };

  window.addEventListener('scroll', handleScroll, { passive: true });

  // Check initial state
  handleScroll();

  return () => {
    window.removeEventListener('scroll', handleScroll);
  };
});
